import { useNavigate } from "react-router-dom"
import {
  aboutMePicBg,
  aboutMePicLabel,
  aboutMePicLq,
} from "../../assets/images"
import { Button, ButtonSize } from "../../components/Button"
import { useTextStorage } from "../../hooks"
import "./AboutMePage.scss"

export const AboutMePage: React.FC = () => {
  const { ts } = useTextStorage()
  const navigate = useNavigate()

  const handleButtonClick = () => {
    navigate("/gallery")
  }
  return (
    <div className="about-me-page-outer-shell">
      <h3>{ts.pages.aboutMe.title}</h3>
      <div className="about-me-page--image-container">
        <img
          src={aboutMePicBg}
          alt="about-me-bg"
          className="about-me-page--bg"
        />
        <img
          src={aboutMePicLq}
          alt="about-me-pic-lq"
          className="about-me-page--lq"
        />
        <img
          src={aboutMePicLabel}
          alt="about-me-pic-label"
          className="about-me-page--pic-label"
        />
      </div>
      <div className="about-me-page--content">
        <h2>{ts.pages.aboutMe.title}</h2>
        {ts.pages.aboutMe.paragraphs.map((paragraph, i) => (
          <p key={`about-me-page-paragraph-${i}`}>{paragraph}</p>
        ))}
        <Button
          text={ts.pages.aboutMe.buttonText}
          size={ButtonSize.MD}
          onClick={handleButtonClick}
        />
      </div>
    </div>
  )
}
